/**
 * MSAL configuration.
 *
 * This module only handles the browser-side Microsoft sign-in popup/redirect.
 * The actual login is finished server-side by AuthContext.loginWithMicrosoft()
 * POSTing MSAL's ACCESS token (not its id token -- confirmed against the
 * live backend, see AuthContext.jsx) to the SAME backend endpoint the Staff
 * Audit Scheduler already uses (`/auth/microsoft`), which matches the
 * signed-in user by azure_oid/email and issues this app's own JWT -- it
 * never auto-creates a user. No separate Azure AD app registration or
 * backend route is introduced by this module.
 */
import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID ?? 'common'}`,
    redirectUri: import.meta.env.VITE_AZURE_REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
};

/** Scopes requested for the sign-in popup. openid/profile/email are enough
 * to identify the user server-side by their Azure OID/email -- this module
 * doesn't call Microsoft Graph directly. */
export const loginRequest = {
  scopes: ['openid', 'profile', 'email'],
};

export const msalInstance = new PublicClientApplication(msalConfig);
